import { useMutation } from '@apollo/client'

import createApiKeyGql from 'gql/apiKey/createApiKey.gql'
import addApiKeyMetadata from 'gql/apiKey/addApiKeyMetadata.gql'
import addGlobalApiKeyMetadata from 'gql/apiKey/addGlobalApiKeyMetadata.gql'
import { useParams } from 'react-router-dom'

export type ApiKeyInput = {
    name: string
    description: string
    account_subnet_ids?: string[]
}

export const useCreateApiKeyService = () => {
    const [mutation] = useMutation(createApiKeyGql)
    const [addApiKeyMetadataMutation] = useMutation(addApiKeyMetadata)
    const [addGlobalApiKeyMetadataMutatio] = useMutation(addGlobalApiKeyMetadata)
    const { id } = useParams()

    const createApiKeyService = async (input: ApiKeyInput) => {
        const { name, description, account_subnet_ids } = input
        const {
            data: { createApiKey },
        } = await mutation({
            variables: {
                input: {
                    name,
                    description,
                    subnet_id: id || null,
                },
            },
        })

        // if (createApiKey) {
        //     // Subnet Api Key
        //     if (account_subnet_ids.length > 0 && id) {
        //         const {
        //             data: { addApiKeyMetadata },
        //         } = await addApiKeyMetadataMutation({
        //             variables: {
        //                 input: {
        //                     price: 0,
        //                     current_month_limit: 0,
        //                     current_month_usage: 0,
        //                     tags: ['string'],
        //                 },
        //                 api_token: createApiKey.data.token,
        //                 id: account_subnet_ids[0],
        //                 subnet_id: id,
        //             },
        //         })
        //     } else {
        //         // Global Api key
        //         const {
        //             data: { addApiKeyMetadata },
        //         } = await addGlobalApiKeyMetadataMutatio({
        //             variables: {
        //                 input: {
        //                     price: 0,
        //                     current_month_limit: 0,
        //                     current_month_usage: 0,
        //                     tags: ['string'],
        //                     is_global: true,
        //                 },
        //                 api_token: createApiKey.data.token,
        //             },
        //         })
        //     }
        // }
        return createApiKey?.data
    }

    return [createApiKeyService]
}
